import recieptCheckIcon from "../../assets/icons/reciept-check.png";
import plusWhiteIcon from "../../assets/icons/plus-circle-white.png";
import rectangleIcon from "../../assets/images/Qrscan-Icon.png";
import editIcon from "../../assets/icons/edit-icon.png";
import { Button1, Button2, ProgressBar } from "../index";
import { Input, Switch } from "antd";
import { useNavigate } from "react-router-dom";
import { useGroups, useGroupExpenses } from "../../data/live";

const money = (amount, currency) =>
  `${Number(amount || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${currency || ""}`.trim();

const displayName = (user, fallback = "Not available") =>
  user?.displayName ||
  [user?.firstName, user?.lastName].filter(Boolean).join(" ").trim() ||
  user?.email ||
  fallback;

const formatDate = (value) => {
  if (!value) return "Not available";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Not available";
  return date.toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "2-digit" });
};

const GroupDetails = ({ setIndex }) => {
  const navigate = useNavigate();
  const { items: groups, loading: groupsLoading } = useGroups();
  const group = groups[0];
  const { items: expenses, loading: expensesLoading } = useGroupExpenses(group?.id);
  const firstExpense = expenses[0];
  const total = expenses.reduce((sum, expense) => sum + Number(expense.amount || 0), 0);
  const currency = firstExpense?.currency || group?.totalCurrency || "";
  const paidByYou = expenses.reduce(
    (sum, expense) => sum + Number(expense.viewerSummary?.youPaid || 0),
    0
  );
  const lentByYou = expenses.reduce(
    (sum, expense) => sum + Number(expense.viewerSummary?.youLent || 0),
    0
  );

  if (groupsLoading || expensesLoading) {
    return <div className="col-12 p-5 text-center text-muted">Loading split payment details...</div>;
  }

  if (!group) {
    return <div className="col-12 p-5 text-center text-muted">No groups found.</div>;
  }

  return (
    <>
      <div className="col-lg-8">
        <div className="d-flex flex-column border rounded-3 gap-3 mt-3">
          <div className="d-flex justify-content-between align-items-center p-3 px-4 border-bottom flex-wrap gap-2 gap-md-0">
            <span className="fs-5 fw-semibold">{group.name}</span>

            <div className="d-flex gap-2 align-items-center ">
              <Button2
                buttonName={"Settle Up"}
                icon={<img src={recieptCheckIcon} alt="" />}
                className={"btn-outline-success"}
                onClick={() => navigate("/settleup")}
              />
              <Button2
                buttonName={"Add Expense"}
                icon={<img src={plusWhiteIcon} alt="add" />}
                className={"btn-dark"}
                divClassName={"gap-2"}
                onClick={() => navigate("/add-expenses")}
              />
            </div>
          </div>

          <div className="d-flex flex-column gap-3 border rounded m-3 mx-4">
            <div className="d-flex justify-content-md-between align-items-center p-3 px-4 border-bottom flex-wrap flex-md-nowrap gap-md-0 gap-2 justify-content-center">
              <div className="d-flex gap-2 align-item-center">
                <div className="align-self-center">
                  <img src={rectangleIcon} alt="" width={44} />
                </div>
                <div className="d-flex flex-column">
                  <span className="fs-6 fw-semibold">{firstExpense?.description || group.name}</span>
                  <span className="fs12px fw-semibold" style={{ color: "#7D7D7D" }}>
                    Created {formatDate(group.createdAt)}
                  </span>
                </div>
              </div>

              <div className="d-flex gap-3 align-items-center">
                <div className="d-flex flex-column">
                  <span className="fs12px fw-semibold align-self-end" style={{ color: "#7D7D7D" }}>
                    You Paid
                  </span>
                  <span className="fs-6 fw-semibold">{money(paidByYou, currency)}</span>
                </div>
                <div className="d-flex flex-column">
                  <span className="fs12px fw-semibold align-self-end" style={{ color: "#7D7D7D" }}>
                    You Lent
                  </span>
                  <span className="fs-6 fw-semibold" style={{ color: "#1bbb6b" }}>
                    {money(lentByYou, currency)}
                  </span>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-md-between justify-content-start gap-md-0 gap-3 align-items-center p-3 px-4 flex-wrap">
              <div className="d-flex gap-3 align-items-center">
                <div>
                  <img src={rectangleIcon} alt="" width={100} />
                </div>
                <div className="d-flex flex-column">
                  <span className="fs14px" style={{ color: "#7D7D7D" }}>
                    {group.name}
                  </span>
                  <span className="fs-5 fw-semibold mb-2">{money(total, currency)}</span>
                  <span className="fs14px" style={{ color: "#7D7D7D" }}>
                    {expenses.length} expenses
                  </span>
                </div>
              </div>

              <Button2
                buttonName={"Edit Expenses"}
                icon={<img src={editIcon} alt="" />}
                className={"btn-outline-success"}
              />
            </div>

            <div className="d-flex gap-5 align-items-center p-3 px-4 flex-wrap flex-md-nowrap">
              <div className="d-flex flex-column gap-2">
                {expenses.length ? (
                  expenses.map((expense) => (
                    <div key={expense.id} className="d-flex align-items-center gap-2">
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center"
                        style={{
                          width: 40,
                          height: 40,
                          backgroundColor: "#EDF8F3",
                          color: "#1BBB6B",
                        }}
                      >
                        {displayName(expense.payer, "?").slice(0, 1)}
                      </div>
                      <span className="fs14px fw-medium" style={{ color: "#7D7D7D" }}>
                        {displayName(expense.payer, expense.paidBy)} paid{" "}
                        <span className="fw-semibold" style={{ color: "#1bbb6b" }}>
                          {money(expense.amount, expense.currency)}
                        </span>{" "}
                        on {formatDate(expense.date)}
                      </span>
                    </div>
                  ))
                ) : (
                  <div className="p-3 text-muted">No expenses in this group.</div>
                )}
              </div>

              <div className="d-flex flex-column gap-2 align-self-start flex-grow-1">
                <label className="fs12px">Comments</label>
                <Input.TextArea
                  className="p-3"
                  placeholder="Add Comments"
                  autoSize={{ minRows: 2, maxRows: 4 }}
                />
                <div className="align-self-end">
                  <Button1 className={"btn-dark"} buttonName={"Post Comment"} disabled />
                </div>
              </div>
            </div>

            <div className="px-4 p-3">
              <ProgressBar
                percent={total > 0 ? Math.min((paidByYou / total) * 100, 100) : 0}
                width={"auto"}
                strokeWidth={20}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-4">
        <div className="d-flex flex-column gap-3 mt-3">
          <div className="d-flex flex-column border rounded-3 gap-3 ">
            <div className="d-flex justify-content-between align-items-center border-bottom p-3 px-4">
              <span className="fs-5 fw-semibold">Group Balance</span>
              <div className="d-flex gap-2 align-items-center">
                <span className="fs12px" style={{ color: "#7D7D7D" }}>
                  Simplify debts
                </span>
                <Switch defaultChecked={true} />
              </div>
            </div>

            <div className="d-flex flex-column gap-3 mx-4 border rounded-3 p-3 px-4">
              {(group.memberDetails || []).length ? (
                group.memberDetails.map((member) => (
                  <div key={member.userId} className="d-flex align-items-center gap-2">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: 34,
                        height: 34,
                        backgroundColor: "#EDF8F3",
                        color: "#1BBB6B",
                      }}
                    >
                      {String(member.name || "?").slice(0, 1)}
                    </div>
                    <div className="d-flex flex-column">
                      <span className="fs14px fw-semibold">{member.name}</span>
                      <span className="fs12px fw-medium" style={{ color: "#7D7D7D" }}>
                        Member
                      </span>
                    </div>
                  </div>
                ))
              ) : (
                <div className="p-3 text-center text-muted">No members found.</div>
              )}
            </div>

            <div className="p-3 px-4 w-100">
              <Button1
                buttonName={"View Details"}
                className={"btn-outline-success w-100"}
                onClick={() => setIndex(1)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GroupDetails;
